import { render } from "./CompanyForm.vue?vue&type=template&id=6191e524&scoped=true&ts=true"
import script from "./CompanyForm.vue?vue&type=script&lang=ts"
export * from "./CompanyForm.vue?vue&type=script&lang=ts"

import "./CompanyForm.vue?vue&type=style&index=0&id=6191e524&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3687640787/src/biomass-frontend-pwc/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6191e524"]])

export default __exports__